var _circle, _circle2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 38.5,
    r: 32.5,
    fill: "#D9D9D9",
    fillOpacity: 0.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.065 62.2856C45.7533 62.2856 51.8085 59.5746 56.1916 55.1915C60.5747 50.8084 63.2857 44.7532 63.2857 38.0649C63.2857 31.3766 60.5747 25.3214 56.1916 20.9382C51.8085 16.5551 45.7533 13.8441 39.065 13.8441C32.3767 13.8441 26.3215 16.5551 21.9383 20.9382C17.5552 25.3214 14.8442 31.3766 14.8442 38.0649C14.8442 44.7532 17.5552 50.8084 21.9383 55.1915C26.3215 59.5746 32.3767 62.2856 39.065 62.2856Z",
    fill: "#FAFAFA",
    fillOpacity: 0.84,
    stroke: "#0033FF",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0378 25.1976L49.5701 29.9041L45.0378 34.6107",
    stroke: "#0033FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.175 36.9639V34.6107C29.175 33.3624 29.6525 32.1653 30.5025 31.2826C31.3525 30.4 32.5052 29.9041 33.7073 29.9041H49.57",
    stroke: "#0033FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7073 51.0835L29.175 46.377L33.7073 41.6705",
    stroke: "#0033FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.57 39.3172V41.6704C49.57 42.9187 49.0925 44.1158 48.2426 44.9985C47.3926 45.8811 46.2398 46.377 45.0378 46.377H29.175",
    stroke: "#0033FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOeIcon);
export default __webpack_public_path__ + "static/media/OE-Icon.ca95f074b7236e2ff7136555601b40de.svg";
export { ForwardRef as ReactComponent };